import { render, staticRenderFns } from "./FacebookOneTap.vue?vue&type=template&id=2bd4b04a&scoped=true&"
import script from "./FacebookOneTap.vue?vue&type=script&lang=js&"
export * from "./FacebookOneTap.vue?vue&type=script&lang=js&"
import style0 from "./FacebookOneTap.vue?vue&type=style&index=0&id=2bd4b04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd4b04a",
  null
  
)

/* custom blocks */
import block0 from "./FacebookOneTap.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports